























































































































import { Component, Mixins } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import { AuthModule } from "@/store/auth.module";
import QuestionDet from "./QuestionDet.vue";
import { Answers, Questionnaire, QuestionnaireDetails, SendAnswersDTO } from "~/dal/questionare";
import { QuestionareModule } from "@/store/questionary.module";


@Component({
  components: { QuestionDet }
})
export default class QuestionnaireDialog extends Mixins(FormValidator) {
  loading: boolean = false;
  formRef = "form";
  curQ: number = 1;

  get fullName() {
    return `${this.user.firstname} ${this.user.lastname} ${
      this.user.middlename ? this.user.middlename : ""
    }`;
  }

  checkForward() {
    if (!this.validateForm()) return;
    this.curQ++;
  }

  get progr() {
    return (100.0 * this.curQ) / this.qCount;
  }

  get user() {
    return AuthModule.user as IUser;
  }

  get question() {
    return this.qCount > 0
      ? QuestionareModule.questionsList[this.curQ - 1]
      : (null as any);
  }

  get quertionNumber() {
    return this.$t("questionnaire.question-number", {
      num: this.curQ,
      count: this.qCount
    });
  }

  get qCount() {
    return QuestionareModule.questionsList.length;
  }

  get showQuestionnaire() {
    if (QuestionareModule.showQuestionnaire) {
      this.curQ = 1;
    }
    return QuestionareModule.showQuestionnaire;
  }

  async closeDialog() {
    QuestionareModule.setneedCheckQuestionnaire(false);
    QuestionareModule.setshowQuestionnaire(false);
  }

  async send() {
    try {
      if (AuthModule.user && AuthModule.user.userid) {
        if (!this.validateForm()) return;
        this.loading = true;
        let result: Answers[] = [];
        QuestionareModule.questionsList.forEach((element: Questionnaire) => {
          result = result.concat(
            element.rqd.map((x: QuestionnaireDetails) => {
              return { var_rid: x.var_rid, checked: x.checked, text: x.text };
            })
          );
        });
        const a: SendAnswersDTO = {
          userId: AuthModule.user.userid,
          answers: result
        };
        await this.closeDialog();
        await QuestionareModule.sendAnswers(a);
        if (AuthModule.user && AuthModule.user.userid)
          await QuestionareModule.getQuestionnaire();
        this.loading = false;
      } else {
        await this.$router.push("/auth");
      }
    } finally {
      this.loading = false;
      //
    }
  }
}
